export default __webpack_public_path__ + "static/media/third-slide-medium.eab1e3a5.jpg";